var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',_vm._l((_vm.singleServiceQueue),function(queue,index){return _c('v-col',{key:index,attrs:{"cols":"12","sm":"6","md":"3"}},[_c('SingleQueue',{attrs:{"queue":queue}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }